import React from 'react'
import "./AboutUs.css";
import photo from "../../../assets/m2c.png"

const AboutUs = () => {
  return (
    <div>
      <section className="about-container">
      <div className="about-hero">
        <div className="about-overlay"></div>
        <div className="about-hero-text">
          <h1>About Us</h1>
          <p>Building impact, not profit.</p>
        </div>
      </div>

      <div className="about-content">
        <div className="about-left">
          <h2>Who We Are</h2>
          <p>
            We are a <strong>not-for-profit program management incorporation</strong>
            <br></br> 
            dedicated to empowering communities and organizations through 
            sustainable development, strategic partnerships, and transparent operations.
          </p>
          <p>
            Our mission is simple — to create lasting change by managing programs that 
            truly matter, ensuring that every project we oversee delivers measurable 
            impact and long-term growth.
          </p>
        </div>

        <div className="about-right">
          <img src={photo} alt="Our Team" />
        </div>
      </div>

      <div className="about-values">
        <h2>Our Core Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <h3>Integrity</h3>
            <p>We manage programs with transparency, accountability, and trust.</p>
          </div>
          <div className="value-card">
            <h3>Community</h3>
            <p>We prioritize people over profit and believe in collective success.</p>
          </div>
          <div className="value-card">
            <h3>Innovation</h3>
            <p>We embrace creativity to deliver smarter, more sustainable outcomes.</p>
          </div>
          <div className="value-card">
            <h3>Impact</h3>
            <p>Our projects are measured by the real change they create.</p>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default AboutUs
